import { render, staticRenderFns } from "./NbSelectInput.vue?vue&type=template&id=63708b7b&"
import script from "./NbSelectInput.vue?vue&type=script&lang=js&"
export * from "./NbSelectInput.vue?vue&type=script&lang=js&"
import style0 from "./NbSelectInput.vue?vue&type=style&index=0&id=63708b7b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports